import { columnRects, resolveLeading, type ComposeOutput, type FrameGeometry, type ParaAttrs } from '@proofroom/schema';

export interface OversetInfo {
  overset: boolean;
  /** Whole lines that do not fit in the last frame (0 when not overset) */
  lines: number;
  /** false when the engine gave no requiredHeight and the count is a floor of 1 */
  exact: boolean;
  lastFrameId?: string;
}

/** How many lines spill past the end of the last frame, from the engine's requiredHeight and the paragraph leading. */
export function oversetInfo(output: ComposeOutput | undefined, frames: FrameGeometry[], attrsAtOverset: Pick<ParaAttrs, 'leading' | 'autoLeading' | 'pointSize'>): OversetInfo {
  const last = frames[frames.length - 1];
  if (!output || !output.overset || !last) return { overset: false, lines: 0, exact: true, lastFrameId: last?.frameId };
  const inner = columnRects(last)[0]?.h ?? last.bounds.h;
  const leading = Math.max(0.5, resolveLeading(attrsAtOverset));
  if (output.requiredHeight === undefined) return { overset: true, lines: 1, exact: false, lastFrameId: last.frameId };
  const over = output.requiredHeight - inner;
  return { overset: true, lines: Math.max(1, Math.ceil(over / leading - 1e-6)), exact: true, lastFrameId: last.frameId };
}
